// import React from 'react';
// import Select from 'react-select';

// // const SelectCustomStyles = {
// //   control: (base) => ({
// //     ...base,
// //     minHeight: 33.1,
// //     maxHeight: 33.1,
// //   }),
// //   indicatorsContainer: (base) => ({
// //     ...base,
// //     padding: "2px 8px",
// //   }),
// //   dropdownIndicator: (base) => ({
// //     ...base,
// //     padding: "2px 8px",
// //   }),
// //   clearIndicator: (base) => ({
// //     ...base,
// //     padding: "2px 8px",
// //   }),
// //   menuPortal: (base) => ({
// //     ...base,
// //     zIndex: 9999, // keep dropdown above everything
// //   }),
// // };

//  const SelectcustomStyles = {
//     control: (base) => ({
//       ...base,
//       maxheight: 42,
//       minHeight: 42,
//       // overflow: "scroll",
//     }),
//     indicatorsContainer: (base) => ({
//       ...base,
//       padding: "0", // Match the padding for both dropdown and clear indicator
//     }),
//     dropdownIndicator: (base) => ({
//       ...base,
//       padding: "2px 8px", // Ensure consistent padding for dropdown indicator
//     }),
//     clearIndicator: (base) => ({
//       ...base,
//       padding: "2px 8px", // Adjust padding for clear indicator to match dropdown
//     }),
//     menuPortal: (base) => ({
//       ...base,
//       zIndex: 9999, // keep dropdown above everything
//     }),
//   };

// const CustomSelect = ({
//   options,
//   onChange,
//   value,
//   isMulti,
//   placeholder,
//   closeMenuOnSelect,
//   styles,
//   isDisabled,
//   formatOptionLabel 
// }) => {
//   return (
//     <Select
//       className="hrms-select"
//       classNamePrefix="hrms-select"
//       // styles={SelectCustomStyles}
//       styles={{
//         ...SelectcustomStyles,
//         ...styles,
//       }}
//       menuPortalTarget={document.body}  // FIX: prevent clipping
//       options={options}
//       onChange={onChange}
//       value={value}
//       isMulti={isMulti}
//       closeMenuOnSelect={closeMenuOnSelect}
//       placeholder={placeholder || "Select..."}
//       isDisabled={isDisabled}
//       isClearable
//       formatOptionLabel={formatOptionLabel} 
//     />
//   );
// };

// export default CustomSelect;


import React from "react";
import Select from "react-select";
import PropTypes from "prop-types";

// --- Default Styles ---
const SelectCustomStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: 42,
    maxHeight: 42,
    borderColor: state.isFocused ? "#2684FF" : "#ced4da",
    boxShadow: state.isFocused ? "0 0 0 1px #2684FF" : "none",
    "&:hover": {
      borderColor: "#2684FF",
    },
    fontSize: "14px",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    padding: "0 6px",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "2px 8px",
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: "2px 8px",
  }),
  valueContainer: (base) => ({
    ...base,
    padding: "2px 8px",
  }),
  placeholder: (base) => ({
    ...base,
    color: "#6c757d",
    fontSize: "14px",
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: "14px",
  }),
  menu: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999,
  }),
  option: (base, { isSelected, isFocused }) => ({
    ...base,
    backgroundColor: isSelected
      ? "#2684FF"
      : isFocused
      ? "#F1F5FB"
      : "white",
    color: isSelected ? "white" : "#333",
    fontSize: "14px",
    cursor: "pointer",
    ":active": {
      backgroundColor: "#EAF2FD",
    },
  }),
};

// --- Custom Select Component ---
const CustomSelect = ({
  options = [],
  value = null,
  onChange,
  onBlur,
  isMulti = false,
  placeholder = "Select...",
  isSearchable = true,
  isClearable = true,
  closeMenuOnSelect = !isMulti,
  isDisabled = false,
  formatOptionLabel,
  styles = {},
  name,
  className = "",
  noOptionsMessage,
}) => {
  return (
    <Select
      inputId={name}
      name={name}
      className={`hrms-select ${className}`}
      classNamePrefix="hrms-select"
      menuPortalTarget={document.body}
      options={options}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      isMulti={isMulti}
      isDisabled={isDisabled}
      isSearchable={isSearchable}
      isClearable={isClearable}
      placeholder={placeholder}
      closeMenuOnSelect={closeMenuOnSelect}
      styles={{ ...SelectCustomStyles, ...styles }}
      formatOptionLabel={formatOptionLabel}
      noOptionsMessage={noOptionsMessage || (() => "No options found")}
    />
  );
};

// --- Prop Types ---
CustomSelect.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  isMulti: PropTypes.bool,
  placeholder: PropTypes.string,
  isSearchable: PropTypes.bool,
  isClearable: PropTypes.bool,
  closeMenuOnSelect: PropTypes.bool,
  isDisabled: PropTypes.bool,
  formatOptionLabel: PropTypes.func,
  styles: PropTypes.object,
  name: PropTypes.string,
  className: PropTypes.string,
  noOptionsMessage: PropTypes.func,
};

export default CustomSelect;

